export default __webpack_public_path__ + "static/media/Human.7abd3c52.jpg";